export default __webpack_public_path__ + "static/media/horizontal4.1ea84455.JPG";